import isDevelopmentEnvironment from '../developer/isDevEnvironment';
export default function showOnlyInDev(menuItem = {}) {
    return Object.assign(Object.assign({}, menuItem), { hideIf: () => !isDevelopmentEnvironment(), badge: 'dev' });
}
